__turbopack_context__.v({
  "badge": "LoyaltyTierBadges-module__q7xZCq__badge",
  "benefits": "LoyaltyTierBadges-module__q7xZCq__benefits",
  "mobile": "LoyaltyTierBadges-module__q7xZCq__mobile",
});
